// Item (a), batch 3: before a task or event is saved, the automatic follow-up emails due around it.

const pad = n => String(n).padStart(2, '0')

function idOf(v, key) {
  if (v === null || v === undefined || v === '') return null
  if (typeof v === 'object') return v[key] === undefined || v[key] === null ? null : Number(v[key])
  var n = Number(v)
  return isNaN(n) ? null : n
}

/** A Date or 'dd/MM/yyyy' as 'dd/MM/yyyy'; null otherwise. */
export function ukDate(d) {
  if (!d) return null
  if (d instanceof Date) return isNaN(d.getTime()) ? null : pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear()
  return /^\d{2}\/\d{2}\/\d{4}$/.test(String(d)) ? String(d) : null
}

/** The query for POST v1/quoteFollowups/dueFor from the record being saved: its quote, contact, customer and date. */
export function warningQuery({ quote, contact, customer, date } = {}) {
  var q = {}
  var quoteVerId = idOf(quote, 'quoteVerId')
  var contactId = idOf(contact, 'contactId')
  var customerId = idOf(customer, 'customerId')
  if (quoteVerId !== null) q.quoteVerId = quoteVerId
  if (contactId !== null) q.contactId = contactId
  if (customerId !== null) q.customerId = customerId
  var day = ukDate(date)
  if (day) q.date = day
  return q
}

/** Whether the query names anything to check. */
export function hasTarget(q) {
  return !!q && (q.quoteVerId !== undefined || q.contactId !== undefined || q.customerId !== undefined)
}

/** The warning line for one email: "Automatic email for Q123/1 due 02/10". */
export function warningLine(row) {
  return 'Automatic email for ' + (row.quoteRef || 'this quote') + ' due ' + (row.dueDay || '')
}
